import { computed as r, openBlock as d, createBlock as l, normalizeClass as c, withCtx as s, createVNode as p, renderSlot as f } from "vue";
import u from "./design-system.es37.js";
import m from "./design-system.es106.js";
import { useListContext as g } from "./design-system.es34.js";
/* empty css                    */
import b from "./design-system.es128.js";
const _ = /* @__PURE__ */ Object.assign({
  name: "DsListSectionHeading"
}, {
  __name: "ListSectionHeading",
  props: {
    border: {
      type: String,
      default: null,
      options: ["none", "inset", "fill"]
    }
  },
  setup(i) {
    const t = i, e = g(), o = r(() => t.border ? t.border : e != null && e.border ? e.border : !1), n = r(() => !!t.border);
    return (a, h) => (d(), l(u, {
      "padding-x": "spacing-200",
      "padding-top": "spacing-150",
      "padding-bottom": "spacing-050",
      class: c(["ds-list-section-heading", {
        "ds-list-section-heading--border-fill": o.value === "fill",
        "ds-list-section-heading--border-inset": o.value === "inset",
        "ds-list-section-heading--border-local": n.value
      }])
    }, {
      default: s(() => [
        p(m, {
          variant: "headline-3",
          color: "text-normal"
        }, {
          default: s(() => [
            f(a.$slots, "default", {}, void 0, !0)
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), D = /* @__PURE__ */ b(_, [["__scopeId", "data-v-33551032"]]);
export {
  D as default
};
//# sourceMappingURL=design-system.es32.js.map
